/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserItem } from '../../models/user-item';

export interface IdentityControllerProfilePicture$Params {
  id: number;
      body: {
'profile'?: Blob;
}
}

export function identityControllerProfilePicture(http: HttpClient, rootUrl: string, params: IdentityControllerProfilePicture$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerProfilePicture.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserItem;
      }>;
    })
  );
}

identityControllerProfilePicture.PATH = '/identity/{id}/picture';
